import classes from "./Newsletter.module.css";
import { Fragment, useRef, useState } from "react";
import Fade from "react-reveal/Fade";

const Newsletter = (props) => {
  const [submitted, setSubmitted] = useState(false);

  const emailRef = useRef();

  const closeSubscription = () => setSubmitted(false);

  const newsLetterFormHandler = (e) => {
    e.preventDefault();
    const enteredEmail = emailRef.current.value;
    if (enteredEmail === "") {
      return;
    }
    const userData = {
      enteredEmail,
    };
    props.isLoading(true);
    fetch("https://dc-luxury-default-rtdb.firebaseio.com/newsletter.json", {
      method: "POST",
      body: JSON.stringify({
        user: userData,
      }),
    });
    props.isLoading(false);
    setSubmitted(true);
    emailRef.current.value = "";
  };

  return (
    <Fade bottom>
      <Fragment>
        <form onSubmit={newsLetterFormHandler} className={classes.form}>
          <h1>sign up our newsletter</h1>
          <div className={classes.forms}>
            <input
              placeholder="Enter Email"
              ref={emailRef}
              id="email"
              type="text"
            />
          </div>
          {submitted ? (
            <Fragment>
              <p className="news">Successful!</p>
              <button type="button" onClick={closeSubscription}>
                OK!
              </button>
            </Fragment>
          ) : (
            <button>Submit</button>
          )}
        </form>
      </Fragment>
    </Fade>
  );
};

export default Newsletter;
